// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 14 hooks for backend/fines.

import { useBackend } from '../useBackend'

/** POST /api/fines/confirmDriver */
export function useConfirmDriver<T = any>() {
  return useBackend<T>('fines/confirmDriver')
}

/** POST /api/fines/createFine */
export function useCreateFine<T = any>() {
  return useBackend<T>('fines/createFine')
}

/** POST /api/fines/deleteFine */
export function useDeleteFine<T = any>() {
  return useBackend<T>('fines/deleteFine')
}

/** POST /api/fines/discardUpload */
export function useDiscardUpload<T = any>() {
  return useBackend<T>('fines/discardUpload')
}

/** POST /api/fines/getEvidenceUrl */
export function useGetEvidenceUrl<T = any>() {
  return useBackend<T>('fines/getEvidenceUrl')
}

/** POST /api/fines/getFine */
export function useGetFine<T = any>() {
  return useBackend<T>('fines/getFine')
}

/** POST /api/fines/getFinesAccess */
export function useGetFinesAccess<T = any>() {
  return useBackend<T>('fines/getFinesAccess')
}

/** POST /api/fines/getFinesOptions */
export function useGetFinesOptions<T = any>() {
  return useBackend<T>('fines/getFinesOptions')
}

/** POST /api/fines/getFinesQueue */
export function useGetFinesQueue<T = any>() {
  return useBackend<T>('fines/getFinesQueue')
}

/** POST /api/fines/setChargedTo */
export function useSetChargedTo<T = any>() {
  return useBackend<T>('fines/setChargedTo')
}

/** POST /api/fines/setFineOffence */
export function useSetFineOffence<T = any>() {
  return useBackend<T>('fines/setFineOffence')
}

/** POST /api/fines/setFineStatus */
export function useSetFineStatus<T = any>() {
  return useBackend<T>('fines/setFineStatus')
}

/** POST /api/fines/updateFine */
export function useUpdateFine<T = any>() {
  return useBackend<T>('fines/updateFine')
}

/** POST /api/fines/uploadEvidence */
export function useUploadEvidence<T = any>() {
  return useBackend<T>('fines/uploadEvidence')
}
